export const FEATURES_RESET_STATE = 'FEATURES_RESET_STATE';
export const FEATURES_CURRENT_ITEM = 'FEATURES_CURRENT_ITEM';

export const FEATURES_REQUEST_LOADING = 'FEATURES_REQUEST_LOADING';
export const FEATURES_REQUEST_SUCCESS = 'FEATURES_REQUEST_SUCCESS';
export const FEATURES_REQUEST_FAILED = 'FEATURES_REQUEST_FAILED';

export const FEATURES_CURRENT_ACTION = 'FEATURES_CURRENT_ACTION';
export const FEATURES_RESET_ACTION = 'FEATURES_RESET_ACTION';